'use strict'

import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import RadioButton from './RadioButton'

import './RadioButton.less'

export default class RadioButtonGroup extends React.Component {

  static propTypes = {
    selectedValue: PropTypes.any,
    onChange: PropTypes.func,
    horizontal: PropTypes.bool,
    spaceAround: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    spaceAround: false
  }

  handleClick = (value) => {
    if (this.props.onChange) {
      this.props.onChange(value)
    }
  }

  render () {
    const classes = classNames('nmc-radio-buttons', {'nmc-radio-buttons-spaced': this.props.spaceAround}, this.props.className)
    const radios = React.Children.map(this.props.children,
      (child) => React.cloneElement(child, {
        selectedValue: this.props.selectedValue,
        horizontal: this.props.horizontal,
        onChange: this.handleClick
      })
    )
    return (
      <div className={classes}>
        {radios}
      </div>
    )
  }
}

export {
  RadioButton
}




// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/RadioButton/RadioButtonGroup.js